import { motion, AnimatePresence } from 'motion/react';
import type { ReactNode } from 'react';
import { useLocation } from 'wouter';

interface PageTransitionProps {
  children: ReactNode;
  direction?: 'forward' | 'backward' | 'fade';
}

const slideVariants = {
  enter: (direction: 'forward' | 'backward') => ({
    x: direction === 'forward' ? '100%' : '-100%',
    opacity: 0,
  }),
  center: {
    x: 0,
    opacity: 1,
  },
  exit: (direction: 'forward' | 'backward') => ({
    x: direction === 'forward' ? '-30%' : '30%',
    opacity: 0,
  }),
};

const fadeVariants = {
  enter: {
    opacity: 0,
  },
  center: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
};

export function PageTransition({ children, direction = 'forward' }: PageTransitionProps) {
  const [location] = useLocation();
  const isFade = direction === 'fade';
  const variants = isFade ? fadeVariants : slideVariants;

  return (
    <AnimatePresence mode="wait" custom={direction}>
      <motion.div
        key={location}
        custom={direction}
        variants={variants}
        initial="enter"
        animate="center"
        exit="exit"
        transition={
          isFade
            ? { duration: 0.3, ease: 'easeInOut' }
            : {
                x: { type: 'spring', stiffness: 200, damping: 25, mass: 0.8 },
                opacity: { duration: 0.35, ease: 'easeInOut' },
              }
        }
        style={{
          width: '100%',
          height: '100%',
        }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
